import { ClientLocal, MessageLocal } from "app/api/types";

export const updateChatMessages = (chats: ClientLocal[], payload: { clientId: number, messages: MessageLocal[] }) =>
	chats.reduce<ClientLocal[]>((clients, client) =>
		client.companionId === payload.clientId
			? [...clients, {
				...client,
				messages: payload.messages ?? []
			}]
			: [...clients, client], [])

export const addChatMessage = (chats: ClientLocal[], payload: { clientId: number, message: MessageLocal }) =>
	chats.reduce<ClientLocal[]>((clients, client) =>
		client.companionId === payload.clientId
			? [...clients, {
				...client,
				messages: [...(client.messages ?? []), payload.message]
			}]
			: [...clients, client], [])
